import {
  NotificationManager,
  //@ts-ignore
} from "react-notifications";

export enum ENotificationType {
  ERROR = "ERROR",
  INFO = "INFO",
  SUCCESS = "SUCCESS",
}

interface Props {
  type: ENotificationType;
  title: string;
  text: string;
  callback?: () => void;
}

export const notification = ({ type, title, text, callback }: Props) => {
  switch (type) {
    case ENotificationType.ERROR:
      NotificationManager.error(text, title, 10000, callback);
      break;
    case ENotificationType.INFO:
      NotificationManager.info(text, title, 10000, callback);
      break;
    case ENotificationType.SUCCESS:
      NotificationManager.success(text, title, 10000, callback);
      break;
    default:
      NotificationManager.info(text, title, 10000, callback);
      break;
  }
};
